// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_lg-0";